import React, { useState } from "react";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";

const CAMPAIGN_TYPE_STATUS = {
  active: "فعال",
  active_alternative: "فعال جایگزین",
  pending: "در حالت انتظار",
  pending_alternative: "در حالت انتظار جایگزین",
};

export default function CheckPositionsHaveDuplicateCampaign() {
  const [positions, setPositions] = useState([]);

  const checkPositions = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const reportPosition = await sendRequestGetReportPosition();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!reportPosition) {
      return;
    }

    setPositions(reportPosition);
  };

  const sendRequestGetReportPosition = async () => {
    const headersRequest = getHeaderForRequest();
    let reportPosition;
    try {
      reportPosition = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/check-positions-have-double-campaign",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return reportPosition.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateReportPositions = () => {
    return (
      <div className="table-responsive pt-3">
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>شماره جایگاه </td>
              <td>وضعیت</td>
            </tr>
          </thead>
          <tbody>
            {positions.map((position) => {
              return (
                <tr>
                  <td>{position.position}</td>
                  <td>{generateStatusPosition(position.status_position)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const generateStatusPosition = (statusesPosition) => {
    statusesPosition = statusesPosition.map((statusPosition) => {
      switch (statusPosition) {
        case "active":
          return CAMPAIGN_TYPE_STATUS.active;
        case "active_alternative":
          return CAMPAIGN_TYPE_STATUS.active_alternative;
        case "pending":
          return CAMPAIGN_TYPE_STATUS.pending;
        case "pending_alternative":
          return CAMPAIGN_TYPE_STATUS.pending_alternative;
      }
    });
    return statusesPosition.toString().replace(",", "-");
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  بررسی تکرار بودن کمپین در جایگاه ها
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    checkPositions();
                  }}
                  className="btn btn-success"
                >
                  بررسی جایگاه ها
                </button>
              </div>
              <div>
                {positions.length == 0 ? <></> : generateReportPositions()}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
